import TeamMemberOne from "../../assets/images/webp/overviewPage/TeamMember1.webp";

import TeamMember from "../../components/TeamMember";

import CONSTANTS from "../../utils/constants/CONSTANTS";

import "./index.scss";

const MeetTheTeam = () => {
  return (
    <div className="meet-the-team">
      <div className="title">
        <div className="heading">Meet the Team</div>
      </div>
      <div className="para">
        Omni-Active® trainers and nutrition coaches are first class professionals, chosen as much for their
        personalities as for their skillset.
      </div>
      <div className="team-members">
        {CONSTANTS.teamImagesOne.map((value) => {
          return <TeamMember img={value.img} key={value.id} memberName={value.name} />;
        })}
      </div>
      <div className="additional-team-members">
        {CONSTANTS.teamImagesTwo.map((value) => {
          return <TeamMember img={value.img} key={value.id} memberName={value.name} />;
        })}
      </div>
    </div>
  );
};

export default MeetTheTeam;
